import {LinkProps, Link as RouterLink} from '@aboutyou/router';
import React from 'react';
import {AriaButtonLinkType} from '../../../types/AriaButtonLink';

export const BaseUnstyledLink = ({
  ref,
  ...props
}: LinkProps & AriaButtonLinkType) => {
  return <RouterLink {...props} ref={ref} />;
};
